"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLabel = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var common_styles_1 = require("@next-components/common-styles");
exports.StyledLabel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  label {\n    ", "\n  }\n  label:nth-child(2) {\n    font-size: 0.75rem;\n  }\n"], ["\n  display: grid;\n  label {\n    ", "\n  }\n  label:nth-child(2) {\n    font-size: 0.75rem;\n  }\n"])), common_styles_1.inputLabels);
var templateObject_1;
//# sourceMappingURL=Label.styled.js.map